var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2085 2.66333L23.2485 20.01H3.16849L13.2085 2.66333ZM0.861828 18.6767C-0.164838 20.45 1.11516 22.6767 3.16849 22.6767H23.2485C25.3018 22.6767 26.5818 20.45 25.5552 18.6767L15.5152 1.33C14.4885 -0.443333 11.9285 -0.443333 10.9018 1.33L0.861828 18.6767ZM11.8752 9.34333V12.01C11.8752 12.7433 12.4752 13.3433 13.2085 13.3433C13.9418 13.3433 14.5418 12.7433 14.5418 12.01V9.34333C14.5418 8.61 13.9418 8.01 13.2085 8.01C12.4752 8.01 11.8752 8.61 11.8752 9.34333ZM11.8752 16.01H14.5418V18.6767H11.8752V16.01Z",
    fill: "#E42131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNotification);
export default __webpack_public_path__ + "static/media/delete-notification.42e1f0479d1c26b04a4bc2ae867644a9.svg";
export { ForwardRef as ReactComponent };